var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 76.8 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.9 52v-14.2h.5l-6.34-19.1h-4.06v-13.61l5.1-5.09h21.9v2.63l2.47-2.63h23.03v2.83l2.9-2.83h21.4v13.58l-5.33 4.67-5 15.05h.53v13.53l-5.16 5.17z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m55.87 1.1-4.47 4.46v-4.46h-21.4l-4.1 4.46v-4.46h-20.33l-4.47 4.46v12h3.78l7.12 21.34h-1v12h24.27l1.83-4.54v4.54h24.27l4.53-4.54v-12h-1l5.61-16.82 5.19-4.52v-11.92z",
    className: "cjd-stroke",
    fill: "#8089a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37.25 35.55h1.4v9.7h-22v-9.7h1.4l-7.85-23.55h-3.46v-9.76h18v9.76h-1.74l4.75 14.2 4.7-14.2h-1.39v-9.76h19.2v9.76h-1.34l4.7 14.2 4.75-14.2h-1.37v-9.76h17.58v9.76h-3.41l-7.85 23.6h1.4v9.7h-22v-9.7h1.4l-3.41-10.38z",
    className: "cjd-fill",
    fill: "#f9fbfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.42bb0599a59ef5ec7909eb35c3e475e2.svg";
export { ForwardRef as ReactComponent };